import React from 'react';
import DesktopDevPageSide300x250Fs from './freestar/DesktopDevPageSide300x250';
const DesktopDevPageSide300x250 = ({ safety ='off' , safetyState  })=>{
    return /*#__PURE__*/ React.createElement(DesktopDevPageSide300x250Fs, {
        safety: safety,
        safetyState: safetyState
    });
};
DesktopDevPageSide300x250.displayName = 'DesktopDevPageSide300x250';
export default DesktopDevPageSide300x250;
